module.exports = __webpack_public_path__ + "static/img/unknown_thumbnail.63c5be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unknown_thumbnail.png
// module id = q/q2
// module chunks = 1